import React, { Component, PropTypes } from 'react';

class PagesSideWide extends Component {
    render() {
        return (
            <div>
                Content of PagesSideWide
                <hr />
                {this.props.children}
            </div>
        );
    }
}

PagesSideWide.propTypes = {
    children: PropTypes.element
};

export default PagesSideWide;



// WEBPACK FOOTER //
// ./src/components/pages/pages/PagesSideWide.js